module.exports = "/dist/fonts/ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/modules/resources/ajax-loader.gif
// module id = 436
// module chunks = 0